.sidebar-section {
    width: 200px;
    min-width: 200px;
}
